import React from "react";
import AboutSection from "../components/about/AboutSection";

function About() {
  return (
    <div>
      <AboutSection />
    </div>
  );
}

export default About;
